// The {client_uuid} placeholder will be automatically replaced with the user's
// client_uuid by the client portal's route guard.
export const newUserRedirectParam = 'redirect=/client/clients/{client_uuid}/client-plan?is_product_wizard_next=true';
